(function () {
  if (window.saleVariantFiltersInitialized) return;
  window.saleVariantFiltersInitialized = true;

  function parseMultiValueParam(value) {
    if (!value) return [];
    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function serializeMultiValueParam(values) {
    return [...new Set(values)].filter(Boolean).join(",");
  }

  function getVariantFilterState() {
    const params = new URLSearchParams(window.location.search);

    return {
      colours: parseMultiValueParam(params.get("sv_colour")),
      size: params.get("sv_size") || "",
      sort: params.get("sv_sort") || "inventory-high"
    };
  }

  function setVariantFilterState(state) {
    const url = new URL(window.location.href);
    const colourValue = serializeMultiValueParam(state.colours || []);

    if (colourValue) {
      url.searchParams.set("sv_colour", colourValue);
    } else {
      url.searchParams.delete("sv_colour");
    }

    if (state.size) {
      url.searchParams.set("sv_size", state.size);
    } else {
      url.searchParams.delete("sv_size");
    }

    if (state.sort && state.sort !== "inventory-high") {
      url.searchParams.set("sv_sort", state.sort);
    } else {
      url.searchParams.delete("sv_sort");
    }

    window.history.replaceState({}, "", url.toString());
  }

  function getSectionRootFromToolbar(toolbar) {
    return toolbar.closest('[id^="shopify-section-"]');
  }

  /* ---------- Load-more state (in-memory, per section) ---------- */

  function getInitialCount(sectionRoot) {
    const container = sectionRoot.querySelector(".js-sale-variants-grid-container");
    const value = container ? parseInt(container.dataset.initialCount, 10) : NaN;
    return Number.isFinite(value) && value > 0 ? value : 20;
  }

  function getLoadStep(sectionRoot) {
    const container = sectionRoot.querySelector(".js-sale-variants-grid-container");
    const value = container ? parseInt(container.dataset.loadStep, 10) : NaN;
    return Number.isFinite(value) && value > 0 ? value : getInitialCount(sectionRoot);
  }

  function getVisibleLimit(sectionRoot) {
    const stored = parseInt(sectionRoot.dataset.visibleLimit, 10);
    if (Number.isFinite(stored) && stored > 0) return stored;
    const initial = getInitialCount(sectionRoot);
    sectionRoot.dataset.visibleLimit = String(initial);
    return initial;
  }

  function setVisibleLimit(sectionRoot, value) {
    sectionRoot.dataset.visibleLimit = String(value);
  }

  function resetVisibleLimit(sectionRoot) {
    sectionRoot.dataset.visibleLimit = String(getInitialCount(sectionRoot));
  }

  function getColourGroupFromName(label) {
    const normalized = (label || "").toLowerCase();
    if (!normalized) return "";

    const keywordMap = [
      ["black", "black"],
      ["white", "white"],
      ["grey", "grey"],
      ["gray", "grey"],
      ["silver", "grey"],
      ["navy", "navy"],
      ["blue", "blue"],
      ["green", "green"],
      ["khaki", "green"],
      ["olive", "green"],
      ["red", "red"],
      ["burgundy", "red"],
      ["maroon", "red"],
      ["pink", "pink"],
      ["fuchsia", "pink"],
      ["purple", "purple"],
      ["violet", "purple"],
      ["lilac", "purple"],
      ["orange", "orange"],
      ["rust", "orange"],
      ["yellow", "yellow"],
      ["mustard", "yellow"],
      ["gold", "yellow"],
      ["brown", "brown"],
      ["chocolate", "brown"],
      ["coffee", "brown"],
      ["espresso", "brown"],
      ["chestnut", "brown"],
      ["beige", "beige"],
      ["tan", "beige"],
      ["sand", "beige"],
      ["stone", "beige"],
      ["oatmeal", "beige"],
      ["cream", "beige"],
      ["ecru", "beige"],
      ["camel", "beige"],
      ["taupe", "beige"],
      ["biscuit", "beige"]
    ];

    for (let i = 0; i < keywordMap.length; i++) {
      if (normalized.includes(keywordMap[i][0])) return keywordMap[i][1];
    }

    return "";
  }

  // Map swatch hex codes (from the "Color" metaobject entries — Display name,
  // Base color, Color/hex) to our internal colour bucket keys. This is the
  // primary, automated source of truth: built from a full export of your
  // Color entries, keyed on hex rather than the fiddly taxonomy reference.
  // New colours won't appear here until added — see the note below the table.
  const HEX_TO_COLOUR = {
    "808080": "grey",
    F5F5DC: "brown",
    "0000FF": "blue",
    "9858B6": "purple",
    DA1B1B: "red",
    "000000": "black",
    A3A780: "beige",
    "6C403E": "red",
    FFF8DC: "beige",
    "77522C": "brown",
    "226839": "green",
    "3F301C": "brown",
    "800000": "red",
    "555568": "blue",
    "566058": "grey",
    A68F66: "beige",
    "475C47": "green",
    "373781": "navy",
    "202040": "navy",
    "100F0F": "black",
    "010160": "navy",
    "5B5757": "grey",
    "4F644F": "green",
    "3D2E2E": "brown",
    "181839": "navy",
    "3B3B3B": "black",
    "511010": "red",
    "212430": "navy",
    "6D738E": "blue",
    "47707B": "blue",
    "524747": "black",
    E160BF: "pink",
    "7F3E5E": "purple",
    "747572": "grey",
    "3C2E25": "brown",
    "263539": "navy",
    "324238": "green",
    "1C2A4D": "navy",
    "2F1316": "brown",
    "222235": "navy",
    "34312A": "brown",
    FFC0CB: "pink",
    "373366": "navy",
    "2E2B55": "navy",
    "262650": "navy",
    C39DA3: "pink",
    "8F9779": "green",
    "6E9DDD": "blue",
    "395C89": "blue",
    "00004D": "navy",
    D193A3: "pink",
    "23214A": "navy",
    "605C5C": "grey",
    "646464": "grey",
    "19484E": "green",
    "144781": "blue",
    "9E9D9D": "grey",
    "4A261E": "brown",
    "0047AB": "blue",
    "2E355B": "navy",
    "645403": "brown",
    "4A5C81": "blue",
    FDFD96: "yellow",
    "008080": "blue",
    "733173": "pink",
    "130630": "navy",
    "332421": "brown",
    C19A6B: "brown",
    CC7722: "orange",
    A3A3A3: "grey",
    A67B5B: "brown",
    "011145": "navy",
    "89A5B0": "blue",
    E5B9B8: "pink",
    "8E9D72": "green",
    "135F77": "blue",
    "968CAE": "purple",
    "447586": "blue",
    "2F6CAF": "blue",
    "333327": "green",
    "141B1D": "green",
    "675E61": "grey",
    "898471": "green",
    "5C2C1E": "brown",
    "314216": "green",
    "2E1C46": "purple",
    A14D35: "brown",
    BD9F63: "beige",
    F69CB5: "pink",
    B7BBA0: "green",
    "86A9E1": "blue",
    "557985": "blue",
    BEA77E: "beige",
    "1E2225": "black",
    "91BCE7": "blue",
    "64C3C7": "blue",
    "575B5E": "grey",
    F1F3F2: "beige",
    "445D40": "green",
    "27562C": "green",
    D5C6B3: "beige",
    "724532": "brown",
    "0782AE": "blue",
    "00DBD4": "blue",
    BCDFFF: "blue",
    "266382": "blue",
    "1C1C1A": "black",
    "2F2F2F": "black",
    EACC5A: "yellow",
    "8F7F34": "yellow",
    "04489B": "navy",
    "5C6878": "blue",
    BD6302: "orange",
    "5A693E": "green",
    "631B27": "red",
    "24261D": "green",
    "9A5630": "brown",
    "005BD3": "blue",
    C7B899: "beige",
    "214926": "green",
    D8C8A7: "beige",
    "5E5F60": "grey",
    "2D2D2D": "navy",
    FFFFFF: "white",
    "1E7C39": "green",
    "5B4133": "brown",
    BD1725: "red",
    B5C1CC: "grey",
    "48579E": "blue",
    "345872": "blue",
    "87CEEB": "blue",
    // Best-guess inferred from hex/name for entries whose admin "Base color"
    // column showed "N references" (multi-colour) rather than a single name —
    // worth a spot check against admin if these look wrong:
    "1578A2": "blue", // Denim Mix
    "9FA0A8": "grey", // Black/Mid Grey/Light Grey
    B7410E: "orange", // Rust
    C74375: "pink", // Fuchsia
    D53219: "orange" // Deep Coral
  };

  function getColourGroupsFromHex(hex) {
    const normalized = (hex || "").replace("#", "").trim().toUpperCase();
    if (!normalized) return [];

    const group = HEX_TO_COLOUR[normalized];
    return group ? [group] : [];
  }

  function getColourGroupsFromCard(card) {
    // Highest priority: the swatch's exact hex code, matched against a table
    // built from your Color metaobject export (Display name / Base color /
    // hex). Deterministic — no guessing.
    const hexGroups = getColourGroupsFromHex(card.dataset.swatchHex);
    if (hexGroups.length) return hexGroups;

    // Next: match the option's own name against known colour words.
    const nameMatch = getColourGroupFromName(card.dataset.colourLabel);
    if (nameMatch) return [nameMatch];

    const hue = Number(card.dataset.swatchHue || "");
    const saturation = Number(card.dataset.swatchSaturation || "");
    const lightness = Number(card.dataset.swatchLightness || "");

    const hasSwatch =
      !Number.isNaN(hue) &&
      !Number.isNaN(saturation) &&
      !Number.isNaN(lightness) &&
      card.dataset.swatchHue !== "";

    if (hasSwatch) {
      if (saturation < 12) {
        if (lightness <= 18) return ["black"];
        if (lightness >= 88) return ["white"];
        return ["grey"];
      }

      if (hue >= 200 && hue <= 250 && lightness < 38) return ["navy"];

      if ((hue >= 0 && hue < 12) || hue >= 355) return ["red"];

      if (
        hue >= 16 &&
        hue < 40 &&
        lightness < 42 &&
        saturation > 20
      ) {
        return ["brown"];
      }

      if (
        hue >= 30 &&
        hue < 55 &&
        saturation < 40 &&
        lightness > 55
      ) {
        return ["beige"];
      }

      if (hue >= 16 && hue < 40) return ["orange"];
      if (hue >= 40 && hue < 68) return ["yellow"];
      if (hue >= 68 && hue < 170) return ["green"];
      if (hue >= 170 && hue < 250) return ["blue"];
      if (hue >= 250 && hue < 320) return ["purple"];
      if (hue >= 320 && hue < 355) return ["pink"];
    }

    return [];
  }

  function makeChip(label, value, type, selected) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "sale-variant-filter__chip" + (selected ? " is-active" : "");

    if (type === "colour") {
      button.classList.add("sale-variant-filter__chip--colour");
      button.classList.add(`sale-variant-filter__chip--${value}`);
    }

    button.dataset.filterType = type;
    button.dataset.filterValue = value;
    button.textContent = label;

    return button;
  }

  function buildToolbar(toolbar) {
    if (!toolbar || toolbar.dataset.built === "true") return;

    const sectionRoot = getSectionRootFromToolbar(toolbar);
    if (!sectionRoot) return;

    const colourContainer = toolbar.querySelector(".js-sale-colour-chips");
    const sizeContainer = toolbar.querySelector(".js-sale-size-chips");
    const sortContainer = toolbar.querySelector(".js-sale-sort-chips");
    const cards = [...sectionRoot.querySelectorAll(".sale-card")];

    if (!colourContainer || !sizeContainer || !cards.length) return;

    const colours = new Map();
    const sockSizes = new Map();
    const apparelSizes = new Map();

    cards.forEach((card) => {
      const groupedColours = getColourGroupsFromCard(card);
      const size = card.dataset.size || "";
      const sizeLabel = card.dataset.sizeLabel || "";

      card.dataset.colourGroups = groupedColours.join(",");

      groupedColours.forEach((groupedColour) => {
        if (groupedColour && !colours.has(groupedColour)) {
          colours.set(
            groupedColour,
            groupedColour.charAt(0).toUpperCase() + groupedColour.slice(1)
          );
        }
      });

      if (size && sizeLabel) {
        const normalizedLabel = sizeLabel.trim();
        const expandedSizes = getExpandedSizeFilters(normalizedLabel);

        card.dataset.sizeFilters = expandedSizes.join(",");

        const isSockSize = /\d/.test(sizeLabel);
        const isApparelSize = /[a-zA-Z]/.test(sizeLabel);

        expandedSizes.forEach((expandedSize) => {
          let displayLabel = expandedSize;

          if (expandedSize === "11-13") {
            displayLabel = "10-13";
          }

          if (expandedSize === "6-9" || expandedSize === "6-10") {
            displayLabel = "6-11";
          }

          const handleized = displayLabel.toLowerCase().replace(/\s+/g, "-");

          if (isSockSize && !sockSizes.has(handleized)) {
            sockSizes.set(handleized, displayLabel);
          }

          if (isApparelSize && !apparelSizes.has(handleized)) {
            apparelSizes.set(handleized, displayLabel);
          }
        });
      }
    });

    const colourOrder = [
      "black",
      "white",
      "grey",
      "navy",
      "blue",
      "green",
      "red",
      "pink",
      "purple",
      "orange",
      "yellow"
    ];

    const sortedColours = [...colours.entries()].sort((a, b) => {
      const aIndex = colourOrder.indexOf(a[0]);
      const bIndex = colourOrder.indexOf(b[0]);
      const aRank = aIndex === -1 ? 999 : aIndex;
      const bRank = bIndex === -1 ? 999 : bIndex;

      if (aRank !== bRank) return aRank - bRank;
      return a[1].localeCompare(b[1]);
    });

    const sortedSockSizes = [...sockSizes.entries()].sort((a, b) =>
      a[1].localeCompare(b[1], undefined, { numeric: true })
    );

    const apparelSizeOrder = [
      "XXS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "XXL",
      "XXXL",
      "XXXXXL",
      "XXXXXXL"
    ];

    const sortedApparelSizes = [...apparelSizes.entries()].sort((a, b) => {
      const labelA = a[1].toUpperCase();
      const labelB = b[1].toUpperCase();

      const indexA = apparelSizeOrder.indexOf(labelA);
      const indexB = apparelSizeOrder.indexOf(labelB);

      const rankA = indexA === -1 ? 999 : indexA;
      const rankB = indexB === -1 ? 999 : indexB;

      if (rankA !== rankB) {
        return rankA - rankB;
      }

      return labelA.localeCompare(labelB);
    });

    colourContainer.innerHTML = "";
    sizeContainer.innerHTML = "";

    sortedColours.forEach(([value, label]) => {
      colourContainer.appendChild(makeChip(label, value, "colour", false));
    });

    function renderSizeGroup(title, entries) {
      if (!entries.length) return;

      const wrapper = document.createElement("div");
      wrapper.className = "sale-size-group";

      const heading = document.createElement("div");
      heading.className = "sale-size-group__title";
      heading.textContent = title;

      const chipsWrap = document.createElement("div");
      chipsWrap.className = "sale-size-group__chips";

      entries.forEach(([value, label]) => {
        chipsWrap.appendChild(makeChip(label, value, "size", false));
      });

      wrapper.appendChild(heading);
      wrapper.appendChild(chipsWrap);
      sizeContainer.appendChild(wrapper);
    }

    renderSizeGroup("Sock Sizes", sortedSockSizes);
    renderSizeGroup("Clothing Sizes", sortedApparelSizes);

    if (sortContainer) {
      sortContainer.innerHTML = "";

      sortContainer.appendChild(
        makeChip("Price: Low to High", "price-low", "sort", false)
      );

      sortContainer.appendChild(
        makeChip("Price: High to Low", "price-high", "sort", false)
      );
    }

    /* Auto-open the relevant panel on first render if a filter/sort is
       already active from the URL, so the selection isn't hidden. */
    const initialState = getVariantFilterState();
    const hasActiveFilter = initialState.colours.length > 0 || initialState.size !== "";
    const hasActiveSort = initialState.sort !== "inventory-high";

    if (hasActiveFilter) {
      openPanel(toolbar, "filter");

      // If only Size is set, land on the Size subtab instead of the default Colour one.
      if (!initialState.colours.length && initialState.size !== "") {
        setActiveSubtab(toolbar, "size");
      }
    } else if (hasActiveSort) {
      openPanel(toolbar, "sort");
    }

    toolbar.dataset.built = "true";
  }

  function openPanel(toolbar, which) {
    const panels = {
      filter: {
        panel: toolbar.querySelector(".js-sale-filter-panel"),
        toggle: toolbar.querySelector(".js-sale-filter-toggle")
      },
      sort: {
        panel: toolbar.querySelector(".js-sale-sort-panel"),
        toggle: toolbar.querySelector(".js-sale-sort-toggle")
      }
    };

    Object.keys(panels).forEach((key) => {
      const { panel, toggle } = panels[key];
      if (!panel || !toggle) return;

      const shouldBeOpen = key === which;
      panel.hidden = !shouldBeOpen;
      toggle.classList.toggle("is-open", shouldBeOpen);
      toggle.setAttribute("aria-expanded", String(shouldBeOpen));
    });
  }

  function closeAllPanels(toolbar) {
    ["filter", "sort"].forEach((key) => {
      const panel = toolbar.querySelector(
        key === "filter" ? ".js-sale-filter-panel" : ".js-sale-sort-panel"
      );
      const toggle = toolbar.querySelector(
        key === "filter" ? ".js-sale-filter-toggle" : ".js-sale-sort-toggle"
      );
      if (!panel || !toggle) return;

      panel.hidden = true;
      toggle.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
    });
  }

  function setActiveSubtab(toolbar, targetName) {
    const subtabs = toolbar.querySelectorAll(".sale-filter-subtab");
    const groups = toolbar.querySelectorAll(".js-sale-filter-group");

    subtabs.forEach((subtab) => {
      subtab.classList.toggle("is-active", subtab.dataset.subtabTarget === targetName);
    });

    groups.forEach((group) => {
      group.classList.toggle("is-active", group.dataset.filterGroup === targetName);
    });
  }

  function updateToolbarState(toolbar) {
    const state = getVariantFilterState();

    toolbar.querySelectorAll(".sale-variant-filter__chip").forEach((chip) => {
      const type = chip.dataset.filterType;
      const value = chip.dataset.filterValue || "";
      let active = false;

      if (type === "colour") active = state.colours.includes(value);
      if (type === "size") active = state.size === value;
      if (type === "sort") active = state.sort === value;

      chip.classList.toggle("is-active", active);
    });
  }

  function getExpandedSizeFilters(sizeValue) {
    const expanded = [sizeValue];

    switch (sizeValue) {
      case "6-9":
        expanded.push("6-11");
        break;

      case "6-10":
        expanded.push("6-11");
        break;

      case "11-13":
        expanded.push("10-13");
        break;
    }

    return expanded;
  }

  function updateLoadMoreUI(sectionRoot, totalMatching, limit, filtersActive) {
    const loadMoreButton = sectionRoot.querySelector(".js-sale-load-more");
    const countLabel = sectionRoot.querySelector(".js-sale-load-more-count");

    const visibleCount = Math.min(limit, totalMatching);
    const hasMore = !filtersActive && totalMatching > limit;

    if (loadMoreButton) {
      loadMoreButton.hidden = !hasMore;
    }

    if (countLabel) {
      countLabel.textContent =
        totalMatching === 0 ? "" : `Showing ${visibleCount} of ${totalMatching}`;
    }
  }

  function applyFiltersAndSort(toolbar) {
    const sectionRoot = getSectionRootFromToolbar(toolbar);
    if (!sectionRoot) return;

    const state = getVariantFilterState();
    const container = sectionRoot.querySelector(".js-sale-variants-grid-container");
    const cards = [...sectionRoot.querySelectorAll(".sale-card")];

    if (!container || !cards.length) return;

    const filtersActive = state.colours.length > 0 || state.size !== "";

    cards.forEach((card) => {
      const cardColourGroups = (card.dataset.colourGroups || "")
        .split(",")
        .map((g) => g.trim())
        .filter(Boolean);

      const cardSizes = (card.dataset.sizeFilters || "")
        .split(",")
        .map((s) => s.trim().toLowerCase())
        .filter(Boolean);

      let matches = true;

      if (
        state.colours.length &&
        !state.colours.some((c) => cardColourGroups.includes(c))
      ) {
        matches = false;
      }

      if (state.size && !cardSizes.includes(state.size.toLowerCase())) {
        matches = false;
      }

      card.dataset.filterMatch = matches ? "true" : "false";
    });

    const matchingCards = cards.filter((card) => card.dataset.filterMatch === "true");

    const sortedCards = [...matchingCards].sort((a, b) => {
      const priceA = Number(a.dataset.variantPriceCents || 0);
      const priceB = Number(b.dataset.variantPriceCents || 0);
      const stockA = Number(a.dataset.variantStock || 0);
      const stockB = Number(b.dataset.variantStock || 0);

      if (state.sort === "inventory-high") {
        const pinnedRankA = Number(a.dataset.pinnedRank || 9999);
        const pinnedRankB = Number(b.dataset.pinnedRank || 9999);

        if (pinnedRankA !== pinnedRankB) {
          return pinnedRankA - pinnedRankB;
        }

        return stockB - stockA;
      }

      if (state.sort === "price-low") return priceA - priceB;
      if (state.sort === "price-high") return priceB - priceA;

      return 0;
    });

    // Filters active -> show every match, ignore the load-more limit.
    // Otherwise show up to whatever's currently been loaded.
    const limit = filtersActive ? sortedCards.length : getVisibleLimit(sectionRoot);

    cards
      .filter((card) => card.dataset.filterMatch !== "true")
      .forEach((card) => {
        card.hidden = true;
        container.appendChild(card);
      });

    sortedCards.forEach((card, index) => {
      container.appendChild(card);
      card.hidden = index >= limit;
    });

    updateLoadMoreUI(sectionRoot, sortedCards.length, limit, filtersActive);
    updateToolbarCount(sectionRoot, sortedCards.length);
  }

  function updateToolbarCount(sectionRoot, totalMatching) {
    const countLabel = sectionRoot.querySelector(".js-sale-toolbar-count");
    if (!countLabel) return;

    countLabel.textContent =
      totalMatching === 1 ? "1 Item" : `${totalMatching} Items`;
  }

  function refreshAllToolbars() {
    const toolbars = document.querySelectorAll(".js-sale-variant-toolbar");

    toolbars.forEach((toolbar) => {
      buildToolbar(toolbar);
      updateToolbarState(toolbar);
      applyFiltersAndSort(toolbar);
    });
  }

  document.addEventListener("click", function (e) {
    const sortToggle = e.target.closest(".js-sale-sort-toggle");
    if (sortToggle) {
      const toolbar = sortToggle.closest(".js-sale-variant-toolbar");
      const panel = toolbar && toolbar.querySelector(".js-sale-sort-panel");
      if (!toolbar || !panel) return;

      const isCurrentlyOpen = !panel.hidden;
      closeAllPanels(toolbar);
      if (!isCurrentlyOpen) openPanel(toolbar, "sort");
      return;
    }

    const filterToggle = e.target.closest(".js-sale-filter-toggle");
    if (filterToggle) {
      const toolbar = filterToggle.closest(".js-sale-variant-toolbar");
      const panel = toolbar && toolbar.querySelector(".js-sale-filter-panel");
      if (!toolbar || !panel) return;

      const isCurrentlyOpen = !panel.hidden;
      closeAllPanels(toolbar);
      if (!isCurrentlyOpen) openPanel(toolbar, "filter");
      return;
    }

    const subtab = e.target.closest(".sale-filter-subtab");
    if (subtab) {
      const toolbar = subtab.closest(".js-sale-variant-toolbar");
      if (!toolbar) return;
      setActiveSubtab(toolbar, subtab.dataset.subtabTarget);
      return;
    }

    const loadMoreButton = e.target.closest(".js-sale-load-more");
    if (loadMoreButton) {
      const sectionRoot = loadMoreButton.closest('[id^="shopify-section-"]');
      const toolbar = sectionRoot && sectionRoot.querySelector(".js-sale-variant-toolbar");
      if (!sectionRoot || !toolbar) return;

      const step = getLoadStep(sectionRoot);
      const current = getVisibleLimit(sectionRoot);
      setVisibleLimit(sectionRoot, current + step);

      applyFiltersAndSort(toolbar);
      return;
    }

    const filterButton = e.target.closest(
      ".sale-variant-filter__chip, .sale-variant-filter__clear-button"
    );

    if (filterButton) {
      const toolbar = filterButton.closest(".js-sale-variant-toolbar");
      if (!toolbar) return;

      const sectionRoot = getSectionRootFromToolbar(toolbar);
      const state = getVariantFilterState();
      const type = filterButton.dataset.filterType;
      const value = filterButton.dataset.filterValue || "";

      if (type === "colour") {
        if (state.colours.includes(value)) {
          state.colours = state.colours.filter((item) => item !== value);
        } else {
          state.colours = [...state.colours, value];
        }
        if (sectionRoot) resetVisibleLimit(sectionRoot);
      }

      if (type === "size") {
        state.size = state.size === value ? "" : value;
        if (sectionRoot) resetVisibleLimit(sectionRoot);
      }

      if (type === "sort") {
        state.sort = state.sort === value ? "inventory-high" : value;
        // Sorting re-orders the current view but doesn't reset load-more progress.
      }

      if (type === "clear") {
        state.colours = [];
        state.size = "";
        state.sort = "inventory-high";
        if (sectionRoot) resetVisibleLimit(sectionRoot);
      }

      setVariantFilterState(state);
      refreshAllToolbars();
    }
  });

  document.addEventListener("DOMContentLoaded", refreshAllToolbars);
  document.addEventListener("shopify:section:load", refreshAllToolbars);
  document.addEventListener("shopify:section:reorder", refreshAllToolbars);
  window.addEventListener("popstate", refreshAllToolbars);
})();

/* ================================================================
   Back to top
================================================================ */
(function () {
  if (window.saleBackToTopInitialized) return;
  window.saleBackToTopInitialized = true;

  function createButton() {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "back-to-top js-back-to-top";
    button.setAttribute("aria-label", "Back to top");
    button.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M12 19V5M12 5L5 12M12 5L19 12" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    document.body.appendChild(button);
    return button;
  }

  function init() {
    const button = document.querySelector(".js-back-to-top") || createButton();

    function toggleVisibility() {
      button.classList.toggle("is-visible", window.scrollY > 480);
    }

    button.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });

    window.addEventListener("scroll", toggleVisibility, { passive: true });
    toggleVisibility();
  }

  document.addEventListener("DOMContentLoaded", init);
})();